import { render, staticRenderFns } from "./indexPicSwiper.vue?vue&type=template&id=332a27e6&scoped=true&"
import script from "./indexPicSwiper.vue?vue&type=script&lang=js&"
export * from "./indexPicSwiper.vue?vue&type=script&lang=js&"
import style0 from "./indexPicSwiper.vue?vue&type=style&index=0&id=332a27e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332a27e6",
  null
  
)

export default component.exports